export default "/images/vendor/flag-icon-css/flags/4x3/hu.svg?bcbd277021f4a8f5a0591c07a54c9caf";